module.exports = __webpack_public_path__ + "assets/images/fountain-04.684559b5e4ea391433ec1739f64cbcac.svg";